import { render, staticRenderFns } from "./HoldMaterialForm.vue?vue&type=template&id=d944780a&scoped=true&"
import script from "./HoldMaterialForm.vue?vue&type=script&lang=ts&"
export * from "./HoldMaterialForm.vue?vue&type=script&lang=ts&"
import style0 from "./HoldMaterialForm.vue?vue&type=style&index=0&id=d944780a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d944780a",
  null
  
)

export default component.exports